export default __webpack_public_path__ + "static/media/3.3a3c79a3.jpg";